import React from 'react';
import Sidebar from '../Dashboard/Sidebar';
import TopBar from '../Dashboard/TopBar';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import Breadcrumbs from '../components/Breadcrumbs';
import { User } from '../types/user';

interface MainLayoutProps {
  user?: User | null;
  currentPath: string;
  onNavigate: (routeId: string, params?: Record<string, string>, data?: Record<string, any>) => void;
  onLogout: () => void;
  children: React.ReactNode;
  contextData?: Record<string, any>;
}

const MainLayout: React.FC<MainLayoutProps> = ({
  user,
  currentPath,
  onNavigate,
  onLogout,
  children,
  contextData = {}
}) => {
  return (
    // Full-screen: sidebar (logo card, menu, user card) on the left; header + content on the right.
    <div style={{ height: '100vh', display: 'flex', overflow: 'hidden', background: '#F6F8FD' }}>
      <Sidebar
        currentPath={currentPath}
        onNavigate={onNavigate}
        onLogout={onLogout}
        user={user}
      />

      <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
        <TopBar user={user} />

        <div style={{
          flex: 1,
          minHeight: 0,
          padding: '14px 28px 24px',
          overflowY: 'auto',
          overflowX: 'hidden',
        }}>
          {/* Breadcrumbs */}
          <Breadcrumbs
            currentPath={currentPath}
            onNavigate={onNavigate}
            contextData={contextData}
          />

          {/* Main Content */}
          <div style={{ marginTop: '12px' }}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainLayout;